export { default as Pagination } from './Pagination'
export { default as PaginationBox } from '../../reason/atoms/Pagination/UIKit__PaginationBox.bs'
